import React, { Component } from 'react';
import { Redirect } from 'react-router';

export interface PropsFromState {
    loginURL: string
    isLoggedIn: boolean
}

export interface PropsFromDispatch {
    updateLoginURL: (url: string) => void
    initiateLogin: (url: string) => void
}

class Login extends Component<PropsFromState & PropsFromDispatch, any> {

    constructor(props: PropsFromState & PropsFromDispatch) {
        super(props)

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    public handleSubmit(event: React.FormEvent<HTMLFormElement>) {
        event.preventDefault();
        const formData = new FormData(event.currentTarget);
        this.props.initiateLogin(formData.get("me") as string)
    }

    public handleChange(event: React.FormEvent<HTMLInputElement>) {
        event.preventDefault();
        this.props.updateLoginURL(event.currentTarget.value as string)
    }

    render() {

        const redirect = this.props.isLoggedIn
        if (redirect) {
            return (
                <Redirect to="/" />
                );
        }

        return (
            <form onSubmit={this.handleSubmit}>
                <label>Enter your URL</label>
                <input
                    name="me"
                    type="url"
                    value={this.props.loginURL}
                    onChange={this.handleChange}
                    className="input-reset db w-100 pa1"
                />

                <input
                    type="submit"
                    value="Login"
                    className="input-reset pa2 w-100 mt1"
                />

            </form>
        );
    }
}

export default Login;
